export const approxTimeDisplay = (minutesToCompletion: number): string => {
  if (minutesToCompletion < 60) {
    // The 5 minute window collapses (2-2min) or inverts (2-1min) once the
    // estimate drops under the floor, so show a single value instead.
    const lowerBound = Math.max(2, minutesToCompletion - 5);
    return lowerBound >= minutesToCompletion
      ? `~${minutesToCompletion}min`
      : `${lowerBound}-${minutesToCompletion}min`;
  }

  if (minutesToCompletion < 24 * 60) {
    const hours = minutesToCompletion / 60;
    const lowerBound = hours - 0.1 * hours;
    return `${lowerBound.toFixed(1)}-${hours.toFixed(1)}hrs`;
  }

  const days = Math.round(minutesToCompletion / 60 / 24);
  return `Approximately ${days} day${days === 1 ? "" : "s"}`;
};

export const etaFromIso = (estimatedCompletionAt: string): string | null => {
  const delta = new Date(estimatedCompletionAt).getTime() - Date.now();
  if (delta <= 0) return null;
  return approxTimeDisplay(Math.ceil(delta / 60000));
};
